import type { EnvironmentConfig } from '../types/environment';

export const environment: EnvironmentConfig = {
	cdnUrl: 'https://app.mygrano.fi',
	production: true,
	envName: 'prod',
	logErrors: true,
	apiUrl: 'https://api.granoshop.fi',
	authUrl: '/do-auth/token',
	adminUrl: 'https://{{BASE_URL}}/admin/customers/{{CUSTOMER_ID}}/storefront/{{STORE_ID}}/settings',
	assetPath: '/assets',
	snackBarConfig: {
		durationWithoutAction: 5000,
		durationWithAction: 10_000,
		verticalPosition: 'top',
		horizontalPosition: 'center',
	},
	titleTemplate: '{{PAGE_TITLE}} - {{STORE_NAME}}',
	fileBucketUrl: 'files.granoshop.fi',
	cognito: {
		userPoolId: 'eu-west-1_5O6XAsKKB',
		clientId: 'ik4u46nc9l33g2gpa4l7q014v',
		identityPoolId: 'eu-west-1:ef70f27c-7ac0-4097-ad50-4af488117766',
	},
	awsRegion: 'eu-west-1',
	awsIotEndpoint: 'a25hwxxy5ttvfl-ats.iot.eu-west-1.amazonaws.com', // spell-checker: disable-line
	customersCanvasSdkUrl: `https://editor.mygrano.fi/prod/resources/generated/iframeapi.js?v=${process.env.BUILD_TIMESTAMP}`,
	editorFileUploadUrl: `https://api.granoshop.fi/v2/customers-canvas/upload-editor-file`,
	sharedSsoHost: 'https://id.grano.fi',
	sharedSsoApi: 'https://api.id.grano.fi',
	maxReorderTimeInDays: 365,
	fileService: {
		endpoint: 'https://23k5f3pdbbh23krfzut22vkaay.appsync-api.eu-west-1.amazonaws.com/graphql',
		apiId: 'wdtyrb5uqvc53j2wzbzmnnq6aa',
		identityPoolId: 'eu-west-1:e9b68e31-12de-4160-8024-f9a5db13210d',
		userPoolId: 'eu-west-1_VJJuCrVyU',
		clientId: '7ml5kt0p4p1urjspsm1mnin7kt',
	},
	featureFlags: {
		enableNewFileInfra: false,
		enableNewLayout: false,
	},
};
